// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-21f90fba] .v-pagination{justify-content:start!important}.opacity[data-v-21f90fba]{opacity:.6;transition:.3s}.opacity[data-v-21f90fba]:hover{opacity:1}[data-v-21f90fba] .v-data-table-header th .v-data-table-header__icon{color:#fff!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
